import author1 from "../../assets/authors/author1.jpg";
import author2 from "../../assets/authors/author2.JPG";

const initialState = [
	{
		id: 1,
		cover_image:
			"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
		category: "Technology",
		title: "Boost your conversion rate",
		author: "Learn with sumit",
		author_image: "https://avatars.githubusercontent.com/u/73503432?v=4",
		date: "11 Jul, 2022",
		time_to_finish: 6,
	},
	{
		id: 2,
		cover_image:
			"https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
		category: "Business",
		title: "Improve your customer experience (Part - 1)",
		author: "Partho Roy",
		author_image: author1,
		date: "20 Mar, 2022",
		time_to_finish: 12,
	},
	{
		id: 3,
		cover_image:
			"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
		category: "Article",
		title: "Prepare for the Marketplace",
		author: "Learn with sumit",
		author_image: "https://avatars.githubusercontent.com/u/73503432?v=4",
		date: "11 Jul, 2022",
		time_to_finish: 8,
	},
	{
		id: 4,
		cover_image:
			"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
		category: "Technology",
		title: "How to use search engine optimization to drive sales",
		author: "Sanjoy Kumar Dhar",
		author_image: author2 ,
		date: "08 Feb, 2022",
		time_to_finish: 11,
	},
	{
		id: 5,
		cover_image:
			"https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
		category: "Business",
		title: "Improve your customer experience (Part - 2)",
		author: "Partho Roy",
		author_image: author1,
		date: "20 Mar, 2022",
		time_to_finish: 9,
	},
];

export default initialState;
